export const options = {
  accountManagement: {
    key: "accountManagement",
    caption: "Управление учетными записями",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия пользователя",
        type: "text",
        placeholder: "Введите",
      },
      position: {
        key: "position",
        label: "Должность",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [],
      },
      department: {
        key: "department",
        label: "Структурное подразделение",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [],
      },
      passValidDate: {
        key: "passValidDate",
        label: "Срок действия пароля (до)",
        type: "date",
      },
      isBlocked: {
        key: "isBlocked",
        label: "Блок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: true, label: "Да", key: "isBlocked" },
          { value: false, label: "Нет", key: "isBlocked" },
        ],
      },
    },
  },
};

export function setOptions(lib, option) {
  Object.values(options).map((item) => {
    if (item.inputsOptions[option]?.options.length === 0) {
      item.inputsOptions[option].options.push(...lib);
    }
  });
}

export const customStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #BC865399",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};

export const customErrorStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #dc3545",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
